import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/script/http'
import VueCookie from 'vue-cookie'

Vue.use(Vuex)
Vue.use(VueCookie)

const store = new Vuex.Store({
  state: {
    data: [],
    basket: {
      amount: 0,
      items: []
    },
    uid: Vue.cookie.get('user-token') || ''
  },
  getters: {
    data (state) {
      return state.data
    },
    basket (state) {
      return state.basket
    }
  },
  mutations: {
    saveData (state, data) {
      Vue.set(state, 'data', data)
    },
    saveBasket (state, data) {
      Vue.set(state, 'basket', data)
    }
  },
  actions: {
    initData ({ commit }) {
      /* eslint-disable */
      function uuidv4 () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      }

      if (!Vue.cookie.get('user-token')) {
        Vue.cookie.set('user-token', uuidv4(), {expires: '1Y', domain: window.location.hostname})
      }
      axios.defaults.headers.common['token'] = Vue.cookie.get('user-token')
      axios({ url: 'get-data' }).then(response => {
        commit('saveData', response.data)
      })
      axios({ url: 'get-basket'}).then(response => {
        var basket = {
          amount: 0,
          items: []
        }
        response.data.forEach((v, k) => {
          basket.amount += v.amount * v.price
          basket.items.push(v)
        })
        commit('saveBasket', basket)
      })
    },
    reBasket ({ commit }) {
      axios('get-basket').then(response => {
        var basket = {
          amount: 0,
          items: []
        }
        response.data.forEach((v, k) => {
          basket.amount += v.amount * v.price
          basket.items.push(v)
        })
        commit('saveBasket', basket)
      })
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/script/vuex.js